import { UnleashClient, type IMutableContext } from '@unleash/proxy-client-vue';

import { environment, unleashConfig } from '@/config';
import { uiAppName } from '@nova/core';

function customFetch(url: string | URL, init?: RequestInit): Promise<Response> {
  const nextRequestInit: RequestInit = { ...(init ?? {}) };
  const headers = new Headers(nextRequestInit.headers);
  headers.set('X-UI-AppName', uiAppName.COMET);
  nextRequestInit.headers = headers;
  return fetch(url, nextRequestInit);
}

export function getFeatureFlagContext(orgId: string): IMutableContext {
  return { properties: { orgId } };
}

export function getFeatureFlagWarehouseContext(warehouseId: string): IMutableContext {
  return { properties: { warehouseId } };
}

const featureFlagConfig = {
  url: unleashConfig.url,
  appName: unleashConfig.appName,
  fetch: customFetch,
  clientKey: unleashConfig.clientKey,
  disableMetrics: true,
  usePOSTrequests: true,
  environment: environment === 'production' ? 'production' : 'development'
};

let client: UnleashClient | undefined;

export function createFeatureFlagClient(): UnleashClient {
  client ??= new UnleashClient(featureFlagConfig);
  return client;
}

// updateContext replaces every property, so keep the ones already applied (orgId and
// warehouseId can be set independently).
async function mergeFeatureFlagContext(featureFlagClient: UnleashClient, context: IMutableContext) {
  await featureFlagClient.updateContext({
    properties: { ...featureFlagClient.getContext().properties, ...context.properties }
  });
}

export async function setFeatureFlagOrgId(orgId?: string | null): Promise<void> {
  if (!client || !orgId || client.getContext().properties?.orgId === orgId) {
    return;
  }

  await mergeFeatureFlagContext(client, getFeatureFlagContext(orgId));
}

export async function setFeatureFlagWarehouseId(warehouseId?: string | null): Promise<void> {
  if (!client || !warehouseId || client.getContext().properties?.warehouseId === warehouseId) {
    return;
  }

  await mergeFeatureFlagContext(client, getFeatureFlagWarehouseContext(warehouseId));
}
